import React from 'react'
import PropTypes from 'prop-types'
import { StaticQuery, graphql } from 'gatsby'

import StandardHeader from '../StandardHeader'
import StandardBody from '../StandardBody'
import StandardFooter from '../StandardFooter'

import styles from './StandardLayout.module.scss'

export const StandardLayout = ({ children }) => (
  <StaticQuery
    query={graphql`
      query SiteTitleQuery {
        site {
          siteMetadata {
            title
          }
        },
      }
    `}
    render={data => (
      <>
        <StandardHeader siteTitle={data.site.siteMetadata.title} />
        <div className={styles.bodyWrapper}>
          <StandardBody>
            {children}
          </StandardBody>
          <StandardFooter />
        </div>
      </>
    )}
  />
)

StandardLayout.propTypes = {
  children: PropTypes.node.isRequired,
}
